import { useState } from 'react';
import RegistrationModal from '@/components/feature/RegistrationModal';

const BasicoIncludes = [
  'Velacion en domicilio o funeraria a eleccion',
  'En domicilio incluye: carpa 3x3m, 80 sillas, 4 cirios, pedestal e imagen religiosa opcional',
  'Ataud metalico o de madera Nivel 1',
  'Cafeteria estandar',
  'Arreglo estetico y embalsamamiento',
  'Transporte en carroza clasica hasta 100 km desde hospital o domicilio',
  'Velacion hasta 24 horas',
  'Orientacion en tramites legales',
];

const PrimeExtra = [
  'Ataud metalico o de madera Nivel 2',
  'Urna clasica o ecologica incluida',
  'Cremacion opcional incluida dentro del plan',
];

const PrimeAll = [...BasicoIncludes, ...PrimeExtra];

export default function PricingPlans() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<'familiar' | 'plus' | undefined>(undefined);

  const openPlanModal = (plan: 'familiar' | 'plus') => {
    setSelectedPlan(plan);
    setModalOpen(true);
  };

  return (
    <section className="bg-[#F7F6FF] py-14 md:py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <p className="text-center text-[#0A0A0A]/60 text-sm md:text-base lg:text-lg max-w-2xl mx-auto mb-10 md:mb-14 leading-relaxed">
          Dos planes disenados para adaptarse a tu familia. Ambos incluyen servicios funerarios por membresia, red aliada y reglas claras desde el registro.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 reveal">
          <div
            className="bg-white rounded-2xl flex flex-col relative order-first"
            style={{
              boxShadow: '0 4px 32px rgba(83,74,183,0.18)',
              border: '2px solid #534AB7',
            }}
          >
            <div className="flex justify-center pt-5 pb-1">
              <span
                className="inline-flex items-center gap-1.5 text-white text-xs font-bold px-5 py-2 rounded-full whitespace-nowrap"
                style={{
                  background: 'linear-gradient(135deg, #534AB7 0%, #7F77DD 100%)',
                  boxShadow: '0 4px 16px rgba(83,74,183,0.35), 0 0 8px rgba(175,169,236,0.25)',
                }}
              >
                <i className="ri-star-fill text-[#AFA9EC] text-xs"></i>
                Mas elegido
              </span>
            </div>

            <div className="bg-[#534AB7] px-5 md:px-8 pt-4 pb-5 md:py-7 text-center md:text-left">
              <p className="text-[#AFA9EC] text-xs font-semibold tracking-widest uppercase mb-2">Plan base</p>
              <h2 className="font-title text-white text-xl md:text-2xl font-bold mb-1">Coverly Basico</h2>
              <div className="flex items-end gap-1 mt-3 md:mt-4 justify-center md:justify-start">
                <span className="font-title text-white text-4xl md:text-6xl font-bold leading-none">$289</span>
                <span className="text-white/60 text-sm mb-2">/mes</span>
              </div>
              <p className="text-[#AFA9EC]/80 text-sm mt-2 font-medium">Desde $9.63 al dia</p>
              <p className="text-white/70 text-xs mt-1.5 font-light">Ideal para la mayoria de las familias</p>

              <div
                className="mt-4 flex items-center gap-2 px-3 py-2.5 rounded-xl text-xs font-medium"
                style={{
                  background: 'rgba(255,255,255,0.12)',
                  border: '1px solid rgba(255,255,255,0.20)',
                }}
              >
                <i className="ri-fire-fill text-orange-300 flex-shrink-0"></i>
                <span className="text-white/90">
                  <strong>Tarifa de registro 2026</strong> - Se respeta mientras la membresia siga activa.
                </span>
              </div>

              <p className="text-white/70 text-sm mt-4 leading-relaxed max-w-[90%] mx-auto md:mx-0 md:max-w-none">
                Titular + hasta 2 familiares directos registrados.
              </p>
            </div>

            <div className="px-5 md:px-8 py-5 md:py-7 flex flex-col flex-1">
              <ul className="flex flex-col gap-2 md:gap-3 flex-1">
                {BasicoIncludes.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-green-500 text-lg"></i>
                    </span>
                    <span className="text-[#0A0A0A]/70 text-xs md:text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => openPlanModal('familiar')}
                className="mt-5 md:mt-8 w-full bg-[#534AB7] hover:bg-[#3C3489] text-white font-semibold py-4 rounded-full text-center text-sm transition-all duration-300 hover:scale-[1.02] whitespace-nowrap cursor-pointer block"
              >
                Solicitar plan Basico
              </button>
            </div>
          </div>

          <div
            className="bg-white rounded-2xl flex flex-col relative"
            style={{ boxShadow: '0 2px 24px rgba(10,10,10,0.10)' }}
          >
            <div className="flex justify-center pt-5 pb-1">
              <span
                className="inline-flex items-center gap-1.5 text-white text-xs font-bold px-5 py-2 rounded-full whitespace-nowrap"
                style={{
                  background: 'linear-gradient(135deg, #0A0A0A 0%, #333 100%)',
                  boxShadow: '0 4px 16px rgba(10,10,10,0.25)',
                }}
              >
                <i className="ri-vip-diamond-fill text-[#AFA9EC] text-xs"></i>
                Mejor valor
              </span>
            </div>

            <div className="bg-[#0A0A0A] px-5 md:px-8 pt-4 pb-5 md:py-7 text-center md:text-left">
              <p className="text-white/40 text-xs font-semibold tracking-widest uppercase mb-2">Plan completo</p>
              <h2 className="font-title text-white text-xl md:text-2xl font-bold mb-1">Coverly Prime</h2>
              <div className="flex items-end gap-1 mt-3 md:mt-4 justify-center md:justify-start">
                <span className="font-title text-white text-4xl md:text-6xl font-bold leading-none">$399</span>
                <span className="text-white/50 text-sm mb-2">/mes</span>
              </div>
              <p className="text-white/55 text-sm mt-2 font-medium">Desde $13.30 al dia</p>
              <p className="text-white/60 text-xs mt-1.5 font-light">Mayor capacidad familiar</p>

              <p className="text-white/60 text-sm mt-4 leading-relaxed max-w-[90%] mx-auto md:mx-0 md:max-w-none">
                Titular + hasta 3 familiares directos registrados. Incluye cremacion opcional dentro del plan.
              </p>
            </div>

            <div className="px-5 md:px-8 py-5 md:py-7 flex flex-col flex-1">
              <ul className="flex flex-col gap-2 md:gap-3 flex-1">
                {PrimeAll.map((item, idx) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-[#534AB7] text-lg"></i>
                    </span>
                    <span className={`text-xs md:text-sm leading-relaxed ${idx >= BasicoIncludes.length ? 'text-[#534AB7] font-medium' : 'text-[#0A0A0A]/70'}`}>{item}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => openPlanModal('plus')}
                className="mt-5 md:mt-8 w-full bg-[#0A0A0A] hover:bg-[#222] text-white font-semibold py-4 rounded-full text-center text-sm transition-all duration-300 hover:scale-[1.02] whitespace-nowrap cursor-pointer block"
              >
                Solicitar plan Prime
              </button>
            </div>
          </div>
        </div>

        <p className="text-center text-[#0A0A0A]/40 text-xs mt-6 md:mt-8 max-w-2xl mx-auto leading-relaxed">
          Los familiares registrados deben ser familia directa verificada con CURP: conyuge, hijos, padres o hermanos del titular.
        </p>
      </div>

      <RegistrationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        preselectedPlan={selectedPlan}
      />
    </section>
  );
}
